import clsx from 'clsx'
import Icon from '@/components/snippets/icon/icon'

const unwrap = (value) => value?.value ?? value

const getFilterFieldKey = (filter) =>
  unwrap(filter?.athos_field) || unwrap(filter?.searchspring_field) || unwrap(filter?.field)

const getFilterDisplayCustomisations = (field) => {
  const filterMetaobject = (typeof GM_STATE !== 'undefined' && GM_STATE.metaobjects?.filters) || []
  return filterMetaobject.find((filter) => getFilterFieldKey(filter) === field) || {}
}

const swatchInnerClasses =
  'swatch-inner shrink-0 rounded-full border border-neutrals-light-grey'

const ColorSwatch = ({ color, className }) => (
  <div className={clsx(swatchInnerClasses, className || 'size-7')} style={{ backgroundColor: color }} />
)

const IconImage = ({ iconObject, width = 16 }) => {
  if (!iconObject) return null

  if (iconObject.icon) {
    const height = iconObject.aspectRatio ? width / iconObject.aspectRatio : width
    return <img src={iconObject.icon} alt="" width={width} height={height} className={swatchInnerClasses} />
  }

  if (iconObject.iconID) {
    return (
      <Icon
        id={iconObject.iconID}
        className="size-7 shrink-0"
      />
    )
  }

  return null
}

export { getFilterDisplayCustomisations, ColorSwatch, IconImage }
